export enum LegalType {
    None,
    EULA,
    TermsandCondition,
    OpenSource,
    ReactJs,
    OpenSourceBuildingSafetyManager,
    OpenSourceBuildingSafetyManagerCloud,
    EatonWirelessControllerEula,
    EatonWirelessControllerOss,
}

export type EulaPayload = {
    status: number;
    data: string;
};
